import Icon from '../../components/Icon';
import Botao from '../../components/Botao';
import styles from './AlertasChamada.module.css';
import { mdiHeadset, mdiPhone, mdiPhoneIncoming, mdiVolumeHigh } from '@mdi/js';
import React, { useCallback } from 'react';
import TextoData from '@/components/tipografia/TextoData';
import VBox from '@/components/layout/VBox';
import HBox from '@/components/layout/HBox';
import { useUserInteracted } from '@/hooks/useUserInteracted';

type AlertaChamadaDto = {};

type AlertasChamadaProps = {
  value: any[];
  isPlayingAudio: boolean;
  onAtender: (chamadaId: number) => void;
};
const AlertasChamada = ({
  value,
  isPlayingAudio,
  onAtender,
}: AlertasChamadaProps) => {
  const userInteracted = useUserInteracted();
  const handleFilaChamadaAtenderClick = useCallback(
    (chamadaId: number) => {
      console.log('handleFilaChamadaAtenderClick', chamadaId);
      onAtender(chamadaId);
    },
    [onAtender],
  );

  const loopHandler = React.useRef<any>(null);
  const audioChamadaRef = React.useRef<HTMLAudioElement>(
    typeof window !== 'undefined' ? new Audio('/sounds/chamada.mp3') : null,
  );

  React.useEffect(() => {
    if (!audioChamadaRef.current || !userInteracted) {
      if (!audioChamadaRef.current || audioChamadaRef.current.paused) return;

      clearInterval(loopHandler.current);
      audioChamadaRef.current.pause();
      audioChamadaRef.current.currentTime = 0;
      loopHandler.current = null;
      return;
    }

    if (value?.length > 0) {
      if (!loopHandler.current) {
        audioChamadaRef.current.play().catch((err) => {
          console.warn('Erro ao tocar som de chamada.', { err });
        });;

        loopHandler.current = setInterval(() => {
          if (!audioChamadaRef.current) return;

          audioChamadaRef.current.play().catch((err) => {
            console.warn('Erro ao tocar som de chamada.', { err });
          });
        }, 15000);
      }
    } else {
      if (loopHandler.current) {
        clearInterval(loopHandler.current);
        audioChamadaRef.current.pause();
        audioChamadaRef.current.currentTime = 0;
        loopHandler.current = null;
      }
    }
  }, [value?.length, userInteracted]);

  React.useEffect(() => {
    if ((!audioChamadaRef.current || !userInteracted)) {
      return
    }

    if (isPlayingAudio) {
      audioChamadaRef.current.volume = 0.05;
    } else {
      audioChamadaRef.current.volume = 1;
    }
  }, [isPlayingAudio])

  return (
    <div style={{ margin: '8px 0' }}>
      {value?.map((item, index) => (
        <div
          key={`alerta-chamada-${index}`}
          className={styles.container}
          title="Este aviso está gerando o som"
        >
          <div className={styles.alerta}>
            <HBox stretch>
              <VBox>
                <span>Nova chamada</span>
                <div
                  style={{
                    fontWeight: 400,
                    fontStyle: 'italic',
                    fontSize: '12px',
                  }}
                >
                  Entr: <TextoData value={item.fila_data_criacao} />
                </div>
              </VBox>
              <Botao
                variant="primary"
                icon={mdiPhoneIncoming}
                onClick={() => handleFilaChamadaAtenderClick(item.id)}
                disabled={item.estado === 'aguarde'}
              >
                {item.estado === 'aguarde' ? 'Aguarde...' : 'Atender'}
              </Botao>
              <Icon
                path={mdiVolumeHigh}
                size={2.5}
                color="var(--tc-color-gray-500)"
              />
            </HBox>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AlertasChamada;
